import { render, staticRenderFns } from "./BrunetteWaiting2.vue?vue&type=template&id=8dee8a4c&"
import script from "./BrunetteWaiting2.vue?vue&type=script&lang=ts&"
export * from "./BrunetteWaiting2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports